import { createEffect, createResource, createSignal, For, Suspense } from "solid-js";
import { PortalSearch } from "~/components/PortalSearch";
import { listBucket, S3Object } from "~/utils";

import "~/_assets/genie-themes.css";


const getThemes = async (): Promise<S3Object[]> => {
	"use server";

	const themes = await listBucket( "_assets/themes/" );

	// Ensure `Contents` is typed as an array and default to an empty array if it's undefined
	return themes ?? [];
};

export default function Themes() {
	const [themes] = createResource( getThemes );
	const [filter, setFilter] = createSignal( "" );

	const [filteredThemes, setFilteredThemes] = createSignal( [] )


	createEffect( () => {
		if ( !themes() ) return;

		const filtered = themes()?.filter( theme => filter() == "" || theme.Key.toLowerCase().includes( filter() ) );

		setFilteredThemes( filtered );
	} );

	return (
		<>
			<PortalSearch placeholder="Filter" onInput={e => setFilter( e.target.value.toLowerCase() )} />

			<div style="font-size:120%;display:flex;justify-content:space-between;">
				<Suspense fallback={<p>Loading themes…</p>}>
					<h1 style="margin-right: 2rem;">{themes() ? themes()?.length : '-'} Themes</h1>
				</Suspense>
			</div>
			<div id="genie-themes" class="genie-filter">
				<Suspense fallback={<p>Loading themes…</p>}>
					<For each={filteredThemes()}>
						{theme => {
							const slug = theme.Key.replace( '.css', '' ).replace( '_assets/themes/', '' );

							return (
								<>
									<link rel="stylesheet" type="text/css" href={`${import.meta.env.GENIE_CLOUD_URL}/${theme.Key}`} />
									<div classList={{ "genie-asset-background": true, [slug]: true }}>
										<div class="genie-asset-outline">
											<h4 class="genie-asset-heading">{slug}</h4>
											<h5 class="genie-asset-subtitle">Fusce sapien lorem dolor cursus</h5>

											<p class="genie-asset-body">
												Pellentesque euismod neque in malesuada eleifend. Donec blandit turpis nec purus consequat
												egestas.
											</p>
										</div>
									</div>

								</> )
						}}
					</For>
				</Suspense>
			</div>
		</>
	)
}


